export default import.meta.ROLLDOWN_FILE_URL_ykb1zIozoJBMq4UvQnlhcQ_d0726dbe4f1d03dd69c09d83